/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { PushSubscriptionKeysFromJSON, PushSubscriptionKeysToJSON, } from './PushSubscriptionKeys';
/**
 * Check if a given object implements the SavePushSubscriptionRequest interface.
 */
export function instanceOfSavePushSubscriptionRequest(value) {
    let isInstance = true;
    return isInstance;
}
export function SavePushSubscriptionRequestFromJSON(json) {
    return SavePushSubscriptionRequestFromJSONTyped(json, false);
}
export function SavePushSubscriptionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'endpoint': !exists(json, 'endpoint') ? undefined : json['endpoint'],
        'keys': !exists(json, 'keys') ? undefined : PushSubscriptionKeysFromJSON(json['keys']),
        'expirationTime': !exists(json, 'expirationTime') ? undefined : (json['expirationTime'] === null ? null : new Date(json['expirationTime'])),
    };
}
export function SavePushSubscriptionRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'endpoint': value.endpoint,
        'keys': PushSubscriptionKeysToJSON(value.keys),
        'expirationTime': value.expirationTime === undefined ? undefined : (value.expirationTime === null ? null : value.expirationTime.toISOString()),
    };
}
